import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TripType } from '../../../models/trips/tripType';
import { TripService } from '../../../services/trip.service';

@Component({
  selector: 'ztsi-trip-type-select',
  templateUrl: './ztsi-trip-type-select.component.html',
  styleUrls: [],
  providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiTripTypeComponent),
			multi: true
		}
	]
})
export class ZtsiTripTypeComponent implements ControlValueAccessor {
	types: TripType[] = [];

	@Input('value') _value: number;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _tripService: TripService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._tripService.getTripTypes().subscribe(response => {
			if (response.length != undefined && response.length > 0) {
				this.types = response;
			}
			else {
				console.log('Unable to load trip type selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-trip-type-select/ztsi-trip-type-select.component.ts